import { __awaiter, __generator } from "tslib";
import { call } from './call';
import { ANDROID_VERSION, APP_VERSION, IOS_VERSION, IS_ANDROID, IS_APP, IS_IOS, IS_PC, IS_RN, IS_SAFARI, IS_WECHAT } from '../constants';
export var getSystemInfo = function () {
    return {
        isIOS: IS_IOS,
        isAndroid: IS_ANDROID,
        isApp: IS_APP,
        appVersion: APP_VERSION,
        isRN: IS_RN,
        isSafari: IS_SAFARI,
        isWeChat: IS_WECHAT,
        isMobile: IS_IOS || IS_ANDROID,
        isPC: IS_PC,
        version: {
            app: APP_VERSION,
            ios: IOS_VERSION,
            android: ANDROID_VERSION,
        },
    };
};
export var getUserInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
    var value;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call('SKPage', 'userInfo')];
            case 1:
                value = _a.sent();
                return [2 /*return*/, value];
        }
    });
}); };
export var getPageInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
    var value;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call('SKPage', 'pageInfo')];
            case 1:
                value = _a.sent();
                return [2 /*return*/, value];
        }
    });
}); };
